import { Button, Card, ConfigProvider, DatePicker, message, Spin } from "antd";
import React, { useState, useEffect, useRef } from "react";
import bookingService from "../../services/booking.service";
import { usePlayrooms } from "../../context/PlayroomsContext";
import { useBooking } from "../../context/BookingContext";
import { useNavigate } from "react-router-dom";
import srRS from "antd/es/locale/sr_RS";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/sr";
import DatepickerIcon from "../../icons/DatepickerIcon";

export default function BookingDateTimeSelection() {
  dayjs.extend(utc);
  dayjs.locale("sr");
  const [freeDates, setFreeDates] = useState([]);
  const [choosenDate, setChoosenDate] = useState(null);
  const { choosenPlayroom } = usePlayrooms();
  const { bookingState, updateBooking } = useBooking();
  const navigate = useNavigate();
  const datePickerRef = useRef(null);
  const [busyDates, setBusyDates] = useState([]);

  const onChange = (date, dateString) => {
    console.log(dateString);
    if (dateString === "") {
      setChoosenDate(null);
      setFreeDates([]);
    } else {
      fetchFreeReservations(dateString);
    }
  };

  const fetchFreeReservations = (date) => {
    bookingService
      .getFreeReservations(choosenPlayroom.id, date)
      .then((response) => {
        if (response.status === 200) {
          console.log("Termini", response.data);
          setFreeDates(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchBusyDates = () => {
    if (choosenPlayroom !== null) {
      bookingService
        .getBusyDates(choosenPlayroom.id)
        .then((response) => {
          if (response.status === 200) {
            console.log(response.data);
            const formattedBusyDates = response.data.map((date) =>
              dayjs.utc(date)
            );
            setBusyDates(formattedBusyDates);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

  };

  const handleSubmit = () => {
    if (choosenDate === null) {
      message.error("Niste izabrali datum i vrijeme");
    } else {
      updateBooking("from", choosenDate.startDateTime);
      updateBooking("to", choosenDate.endDateTime);
      navigate("/package-selection");
    }
  };

  const extractTime = (timestamp) => {
    const time = dayjs.utc(timestamp).format("HH:mm");
    return time;
  };

  const handleTimeSelect = (time) => {
    setChoosenDate(time);
  };

  useEffect(() => {
    fetchBusyDates();
    if (datePickerRef.current) {
      const inputElement = datePickerRef.current.querySelector("input");
      if (inputElement) {
        inputElement.setAttribute("inputmode", "none");
      }
    }
  }, []);

  useEffect(() => {
    if (choosenPlayroom === null) {
      navigate("/");
    }
  }, [choosenPlayroom, navigate]);

  const isDateDisabled = (current) => {
    // Check if the date is in the past
    if (current && current < dayjs().startOf("day")) {
      return true;
    }

    // Check if the date is in the list of busy dates
    if (busyDates.some((busyDate) => current.isSame(busyDate, "day"))) {
      return true;
    }

    // Check if the date is 150 or more days from today
    const today = dayjs().startOf("day");
    if (current && current >= today.add(150, 'day').startOf('day')) {
      return true;
    }

    return false;
  };

  if (choosenPlayroom === null) {
    return <Spin />;
  }

  return (
    <div className="flex flex-col items-center justify-start h-full space-y-5">
      <div className="flex flex-col items-center space-y-2 py-4">
        <p className={"font-bold text-footerBlue text-4xl lg:text-7xl py-2 lg:py-10"}>
          {choosenPlayroom.name}
        </p>
        <label
          className="block text-footerBlue font-semibold text-xl lg:py-4"
          htmlFor="expectedNumberOfAdults"
        >
          Izaberi datum proslave rođendana:
        </label>
        <div ref={datePickerRef}>
          <ConfigProvider locale={srRS}>
            <DatePicker
              picker="date"
              className="text-lg font-semibold h-14 w-80 bg-datepickerGray rounded-[16px]"
              onChange={onChange}
              allowClear
              disabledDate={isDateDisabled}
              suffixIcon={<DatepickerIcon />}
            />
          </ConfigProvider>
        </div>
      </div>
      <div className="w-[1px] h-20 bg-gray-300 my-4"></div>

      <div className="flex flex-col items-center space-y-4 py-4 h-full">
        <label
          className="block text-footerBlue font-semibold text-xl lg:py-4"
          htmlFor="expectedNumberOfAdults"
        >
          Izaberi vrijeme proslave rođendana:
        </label>
        {freeDates.length > 0 ? (
          freeDates.map((time) => (
            <Card
              key={time.startDateTime}
              className={`w-60 h-15 text-2xl font-semibold shadow-md cursor-pointer rounded-[16px] ${choosenDate && choosenDate.startDateTime === time.startDateTime
                ? "bg-gray-600 text-white"
                : "bg-datepickerGray text-datepickerTextGray"
                }`}
              onClick={() => handleTimeSelect(time)}
            >
              {`${extractTime(time.startDateTime)} - ${extractTime(
                time.endDateTime
              )}`}
            </Card>
          ))
        ) : (
          <label
            className="block text-red-600 font-semibold mb-2"
            htmlFor="expectedNumberOfAdults"
          >
            Nema slobodnih termina za izabrani datum!
          </label>
        )}
      </div>
      <div className="w-[1px] h-20 bg-gray-300 my-4"></div>

      <div className="flex flex-col items-center space-y-2 py-4 md:pb-6">
        <Button
          className="w-80 text-xl bg-buttonYellow text-footerBlue hover:bg-footerBlue hover:text-white rounded-[36px]  font-bold py-6"
          type="submit"
          onClick={handleSubmit}
        >
          POTVRDI TERMIN
        </Button>
      </div>
    </div>
  );
}
